import ReportPage from './ReportPage'

export default function ReportPoliticaPreco({className = ''}: {className?: string}) {
  return <ReportPage type='politica_preco' className={className} />
}
